import type { FilterParams } from "epsm-api-types";
import type { NEWS_SECTOR } from "../../../types";

export function getNewsFilterBySector(sectors?: NEWS_SECTOR[]): FilterParams {
	if (!sectors?.length) return [];

	return [
		{
			name: "sector",
			condition: "in",
			value: sectors,
		},
	];
}
